/**
 * Sidebar Navigation Tour Configuration
 * Introduces users to the sidebar menu items and navigation
 */

import { TourDefinition } from './tour.types';

export const sidebarNavigationTour: TourDefinition = {
  id: 'sidebar-navigation-tour',
  name: 'Sidebar Navigation',
  page: '/dashboard', // Starts on dashboard since sidebar is always visible
  version: 9, // v9: Moved Appointments + Reminders steps to under Leads (matches sidebar reorder)
  nextTourId: 'navbar-tour', // Chain to navbar tour after completion
  steps: [
    {
      id: 'sidebar-intro',
      targetSelector: '[data-tour="sidebar-nav"]',
      title: 'Your Navigation Menu',
      description:
        'The sidebar is your main navigation hub. Access all features from here. Let me show you what each section does!',
      placement: 'right',
    },
    {
      id: 'nav-dashboard',
      targetSelector: '[data-tour="nav-dashboard"]',
      title: 'Dashboard',
      description:
        'Your home base! View key metrics, recent activity, and get a quick overview of your business performance.',
      placement: 'right',
    },
    {
      id: 'nav-agency-dashboard',
      targetSelector: '[data-tour="nav-agency-dashboard"]',
      title: 'Agency Dashboard',
      description:
        'Track your team\'s performance and manage agents from this dashboard.',
      placement: 'right',
    },
    {
      id: 'nav-leaderboard',
      targetSelector: '[data-tour="nav-leaderboard"]',
      title: 'Agent Leaderboard',
      description:
        'See how you and your team rank! View performance rankings based on premium, sales, and other key metrics.',
      placement: 'right',
    },
    {
      id: 'nav-leads',
      targetSelector: '[data-tour="nav-leads"]',
      title: 'Leads',
      description:
        'Manage all your leads here. Add new leads, track their status, and access their complete history.',
      placement: 'right',
    },
    {
      id: 'nav-appointments',
      targetSelector: '[data-tour="nav-appointments"]',
      title: 'Appointments',
      description:
        'Schedule and manage appointments with your leads. Never miss a meeting with built-in reminders.',
      placement: 'right',
    },
    {
      id: 'nav-reminders',
      targetSelector: '[data-tour="nav-reminders"]',
      title: 'Reminders',
      description:
        'Set follow-up reminders for yourself. Stay organized and never forget to reach out to a lead.',
      placement: 'right',
    },
    {
      id: 'nav-lead-assignment',
      targetSelector: '[data-tour="nav-lead-assignment"]',
      title: 'Lead Assignment',
      description:
        'Distribute leads to your team members. Track who\'s working on what and optimize your sales pipeline.',
      placement: 'right',
    },
    {
      id: 'nav-dialer',
      targetSelector: '[data-tour="nav-dialer"]',
      title: 'Dialer',
      description:
        'Make calls directly from your browser! The power dialer helps you connect with leads efficiently.',
      placement: 'right',
    },
    {
      id: 'nav-communication',
      targetSelector: '[data-tour="nav-communication"]',
      title: 'Communications',
      description:
        'View your complete communication history. Listen to call recordings and see all your text message conversations.',
      placement: 'right',
    },
    {
      id: 'nav-fax',
      targetSelector: '[data-tour="nav-fax"]',
      title: 'Fax',
      description:
        'Send and receive faxes digitally. No fax machine needed - manage all your fax communications right from the app.',
      placement: 'right',
    },
    {
      id: 'nav-resources',
      targetSelector: '[data-tour="nav-resources"]',
      title: 'Resources',
      description:
        'Access training materials, documents, and helpful resources to grow your insurance business.',
      placement: 'right',
    },
    {
      id: 'nav-settings',
      targetSelector: '[data-tour="nav-settings"]',
      title: 'Settings',
      description:
        'Customize your account, manage phone numbers, update billing, and configure your preferences.',
      placement: 'right',
    },
    {
      id: 'insura-help-intro',
      targetSelector: '[data-tour="insura-help"]',
      title: 'Need Help?',
      description:
        'InsuraHelp is your AI assistant! Click here anytime to ask questions about the app or get help navigating features.',
      placement: 'left',
    },
  ],
};
